import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import ActiveTaskList from './components/otherTasks/ActiveTaskList';

const ActiveTasks = () => {
  return renderComponent(<ActiveTaskList />);
};

export default ActiveTasks;
